import { createDirectus, rest, staticToken } from '@directus/sdk';

const DIRECTUS_REQUEST_TIMEOUT_MS = 8000;

const isBuildPhase = () => process.env.NEXT_PHASE === 'phase-production-build';

const fetchWithTimeout: typeof fetch = (input, init) =>
  isBuildPhase()
    ? fetch(input, init)
    : fetch(input, {
        ...init,
        signal: init?.signal ?? AbortSignal.timeout(DIRECTUS_REQUEST_TIMEOUT_MS),
      });

const directus = createDirectus(process.env.NEXT_PUBLIC_DIRECTUS_URL!, {
  globals: { fetch: fetchWithTimeout },
})
  .with(rest())
  .with(staticToken(process.env.NEXT_DIRECTUS_ADMIN_TOKEN!));

export default directus;
export const getDirectusClient = () => directus;

type ImageTransformOptions = {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'webp' | 'avif' | 'jpg' | 'png';
  fit?: 'cover' | 'contain' | 'inside' | 'outside';
};

const buildImageQuery = (options?: ImageTransformOptions) => {
  if (!options) return '';

  const params = new URLSearchParams();

  if (options.width) params.set('width', String(options.width));
  if (options.height) params.set('height', String(options.height));
  if (options.quality) params.set('quality', String(options.quality));
  if (options.format) params.set('format', options.format);
  if (options.fit) params.set('fit', options.fit);

  const query = params.toString();
  return query ? `?${query}` : '';
};

export const getReadableImageUrl = (
  imageId: string,
  filename?: string,
  options?: ImageTransformOptions
) => {
  if (!imageId) return '';

  const sanitizedFilename = filename?.trim();
  const path = sanitizedFilename ? `${imageId}/${sanitizedFilename}` : imageId;

  return `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${path}${buildImageQuery(options)}`;
};

export const getIconUrl = (iconId: string) => {
  return `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${iconId}`;
};